import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState('Settings', ['isMosaicModeActive'])
  },
  methods: {
    mountMosaic(defaultSize = 17, rowHeight = 10, gapSize = 3, imageRef = 'image', rootRef = 'root') {
      const $ref = this.$refs[imageRef];
      if ($ref) {
        $ref.onload = () => {
          let tileHeight = this.isMosaicModeActive
            ? Math.floor(($ref.clientHeight || 0) / rowHeight)
            : defaultSize

          if (this.$refs[rootRef]) {
            this.$refs[rootRef].style.gridRowEnd = `span ${tileHeight + gapSize}`
          }
        }
      } else if (this.$refs[rootRef]) {
        this.$refs[rootRef].style.gridRowEnd = `span ${ defaultSize + gapSize }`
      }
    }
  }
}
